import React from 'react';

import { Typography, TypographyProps } from '_lib/components/Typography/Typography';
import { toSxArray } from '_lib/utils/helpers';

export type TextBlockTypographyProps = Omit<TypographyProps, 'text'> & {
  text: string | null | undefined;
  defaultTextValue?: string;
};

/** Typography with some sane defaults for when we expect larger text blocks */
export const TextBlockTypography = (props: TextBlockTypographyProps) => {
  const { text, defaultTextValue, sx, ...otherProps } = props;

  return (
    <Typography
      {...otherProps}
      text={text || (defaultTextValue !== undefined ? defaultTextValue : 'N/A')}
      sx={[...toSxArray(sx), { overflowWrap: 'break-word', whiteSpace: 'pre-line' }]}
    />
  );
};
